import { NavLink, Outlet, Link } from "react-router-dom";
import { LayoutDashboard, Package, Warehouse, ClipboardList, Users, TicketPercent, BarChart3, ArrowLeft, Scissors } from "lucide-react";
import { useAuth } from "../../context/AuthContext";

const NAV = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/products", label: "Products", icon: Package },
  { to: "/admin/inventory", label: "Inventory", icon: Warehouse },
  { to: "/admin/orders", label: "Orders", icon: ClipboardList },
  { to: "/admin/custom-orders", label: "Custom", icon: Scissors },
  { to: "/admin/customers", label: "Customers", icon: Users },
  { to: "/admin/coupons", label: "Coupons", icon: TicketPercent },
  { to: "/admin/analytics", label: "Analytics", icon: BarChart3 },
];

export default function AdminLayout() {
  const { user } = useAuth();
  return (
    <div className="min-h-screen bg-ink flex" data-testid="admin-layout">
      <aside className="w-56 shrink-0 border-r border-[#262626] bg-ink-surface flex flex-col fixed inset-y-0 z-40 hidden md:flex">
        <div className="p-5 border-b border-[#262626]">
          <Link to="/admin" className="flex items-center gap-2">
            <img src="/logo.png" alt="DN" className="h-9 w-9 object-contain" />
            <div className="font-display font-extrabold text-xs tracking-widest">
              <span className="gold-text">DRESSEDIN</span>
              <span className="block text-[8px] text-muted-foreground tracking-[0.3em]">ADMIN CONSOLE</span>
            </div>
          </Link>
        </div>
        <nav className="flex-1 p-3 space-y-1">
          {NAV.map(({ to, label, icon: Icon, end }) => (
            <NavLink key={to} to={to} end={end} data-testid={`admin-nav-${label.toLowerCase()}`}
              className={({ isActive }) => `flex items-center gap-3 px-3 py-2.5 text-xs uppercase tracking-widest font-bold transition-colors ${isActive ? "bg-gold text-ink" : "text-muted-foreground hover:text-gold hover:bg-ink-elevated"}`}>
              <Icon size={15} /> {label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t border-[#262626]">
          <Link to="/" className="flex items-center gap-2 px-3 py-2 text-xs text-muted-foreground hover:text-gold transition-colors" data-testid="admin-back-to-store">
            <ArrowLeft size={14} /> Back to store
          </Link>
          <p className="px-3 py-2 text-[10px] text-muted-foreground truncate">{user?.email}</p>
        </div>
      </aside>

      {/* Mobile top bar */}
      <div className="md:hidden fixed top-0 inset-x-0 z-40 bg-ink-surface border-b border-[#262626] flex items-center gap-1 overflow-x-auto px-2 py-2">
        <img src="/logo.png" alt="DN" className="h-7 w-7 object-contain shrink-0" />
        {NAV.map(({ to, label, end }) => (
          <NavLink key={to} to={to} end={end}
            className={({ isActive }) => `px-3 py-2 text-[10px] uppercase tracking-wider font-bold whitespace-nowrap ${isActive ? "text-gold" : "text-muted-foreground"}`}>
            {label}
          </NavLink>
        ))}
      </div>

      <main className="flex-1 md:ml-56 p-4 md:p-8 pt-16 md:pt-8 min-w-0">
        <Outlet />
      </main>
    </div>
  );
}
